/**
 * QUOTATION KANBAN CARD — adattatore entity-specific della card preventivo.
 *
 * Non ridisegna lo scheletro (root/top/titolo/meta/foot): quello è di {@link KbCard},
 * condiviso con i task. Qui si passano solo i dati del preventivo: titolo (link al
 * dettaglio), codice + chip stato nel `meta`, importo + scadenza nel `foot`. TS-101: la
 * board è a filtro — nessun cestino, il preventivo cambia board cambiando stato/pipeline,
 * non "uscendo" da qui. `draggable`: la card è trascinabile, KbCard ferma il pointer su
 * titolo così cliccarlo non avvia il drag.
 */

import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import { KbCard } from '../../components/KbCard';
import type { Quotation } from './quotationTypes';

const currencyFormat = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

export function QuotationKanbanCard({ quotation }: { quotation: Quotation }) {
  const { t } = useTranslation();
  const { quotationId, title, externalCode, amount, dueDate, status } = quotation;

  return (
    <KbCard
      title={title || `#${quotationId}`}
      titleTo={`/quotations/${quotationId}`}
      draggable
      meta={
        <>
          {externalCode ? <span className="kb-card__tag">{externalCode}</span> : <span />}
          <Chip
            className="chip-quotation-status"
            data-status={status}
            label={t(`quotation.statuses.${status}`, { defaultValue: status })}
            size="small"
          />
        </>
      }
      foot={
        <>
          <span className="kb-card__amount">{currencyFormat.format(amount)}</span>
          {dueDate && (
            <span className="kb-card__due">{new Date(dueDate).toLocaleDateString('it-IT')}</span>
          )}
        </>
      }
    />
  );
}
